<template>
    <div class="page">

        <div class="project-header">
            <div class="project-title">订制化体检方案</div>
            <div class="project-user">
                <div class="user-avatar-left">

                    <img src="../../assets/images/avatar-female.png" class="user-avatar-img"
                        v-if="activeUserProfile && activeUserProfile.sex == 2" />
                    <img src="../../assets/images/avatar-male.png" class="user-avatar-img" v-else />
                </div>
                <div class="user-profile-right">
                    <div class="user-profile-name">{{activeUserProfile.name}}</div>
                    <div class="user-profile-info"><span
                            style="margin-right:12px">{{activeUserProfile.sex|sexFormat}}</span>{{activeUserProfile.birth|calcAge}}岁
                    </div>
                </div>
            </div>
        </div>
        <!-- 套餐详情 -->
        <div class="package-wrap">
            <div class="package-header">{{projectData.packageName}}</div>
            <div class="package-items-category">
                <div class="package-items-category-box">
                    <div class="category-icon">
                        <img src="@/assets/images/icon-medical1.png" />
                    </div>
                    <div class="category-name">常规检查</div>
                    <div><span class="category-tag">{{items0.length}} 项</span></div>
                </div>
                <div class="package-items-category-box">
                    <div class="category-icon">
                        <img src="@/assets/images/icon-medical3.png" />
                    </div>
                    <div class="category-name">医技检查</div>
                    <div><span class="category-tag">{{items1.length}} 项</span></div>
                </div>
                <div class="package-items-category-box">
                    <div class="category-icon">
                        <img src="@/assets/images/icon-medical2.png" />
                    </div>
                    <div class="category-name">检验项目</div>
                    <div><span class="category-tag">{{items2.length}} 项</span></div>
                </div>
                <div class="package-items-category-box">
                    <div class="category-icon">
                        <img src="@/assets/images/icon-medical4.png" />
                    </div>
                    <div class="category-name">其它项目</div>
                    <div><span class="category-tag">{{items3.length}} 项</span></div>
                </div>
            </div>
            <transition name="van-slide-down">
                <ul class="package-item-list" v-show="packageExpand">
                    <li class="package-item-detail" v-for="(it,index) in projectData.packageItems" :key="it.id"
                        @click="popupItem(it)">
                        <div class="checkitem-row">
                            <div class="checkitem-title">
                                <span class="checkitem-name">{{it.alias && it.alias !=="" ? it.alias : it.name}}</span>
                                <!-- <span class="checkitem-price">￥{{it.price}}</span> -->

                                <van-icon name="arrow" size="12px" style="margin-top:6px" />
                            </div>
                            <span class="checkitem-desc">{{it.description}}</span>
                            <div class="checkitem-footer" v-show="it.generalTips !=null || it.importantTips!=null">
                                <span v-show="it.generalTips" class="checkitem-tips">{{it.generalTips}}</span>
                                <span v-show="it.importantTips" class="checkitem-tips red">{{it.importantTips}}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </transition>
            <div class="package-detail-toggle">
                <div v-if="packageExpand" @click="packageExpand = !packageExpand">
                    收起
                    <van-icon name="arrow-up" size="12px" />
                </div>
                <div v-else @click="packageExpand = !packageExpand">
                    查看套餐详情
                    <van-icon name="arrow-down" size="12px" />
                </div>
            </div>
        </div>

        <!-- 加项详情 -->
        <div class="additem-wrap">
            <div class="additem-header">选择加项 <span class="additem-header-subtext">请根据个人情况选择</span></div>
            <div class="additem-main">
                <van-sidebar v-model="myAdditemCateKey">
                    <van-sidebar-item title="推荐项目" dot />
                    </van-sidebar-item>
                    <!-- <van-sidebar-item title="防癌筛查" />
                    <van-sidebar-item title="心脑血管" />
                    <van-sidebar-item title="消化系统" />
                    <van-sidebar-item title="妇科专项" /> -->
                </van-sidebar>
                <div class="additem-list">
                    <ul class="recommand-item-list" v-if="projectData.addCombos && projectData.addCombos.length>0">
                        <li class="recommand-item-detail" v-for="(it,index) in projectData.addCombos" :key="it.comboId"
                            @click="">
                            <div class="checkitem-row">
                                <div class="checkitem-title">
                                    <div><span class="item-tag item-tag--orange">组合</span></div>
                                    <span class="checkitem-name">{{it.comboName}}</span>
                                    <span class="checkitem-price">￥{{it.price}}</span>

                                    <!-- <van-icon name="arrow" size="12px" style="margin-top:6px" /> -->
                                </div>
                                <span class="checkitem-desc">{{it.description}}</span>
                                <div class="checkitem-footer">
                                    <div class="checkitem-tips-wrap">
                                        <span v-show="it.generalTips" class="checkitem-tips">{{it.generalTips}}</span>
                                        <span v-show="it.importantTips"
                                            class="checkitem-tips red">{{it.importantTips}}</span>
                                    </div>
                                    <div class="checkitem-action">
                                        <van-checkbox v-model="it.isSelected">选择</van-checkbox>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <ul class="recommand-item-list">
                        <li class="recommand-item-detail" v-for="(it,index) in projectData.addItems" :key="it.id"
                            @click="">
                            <div class="checkitem-row">
                                <div class="checkitem-title">
                                    <div><span class="item-tag item-tag--yellow">加项</span></div>
                                    <span
                                        class="checkitem-name">{{it.alias && it.alias !=="" ? it.alias : it.name}}</span>
                                    <span class="checkitem-price">￥{{it.price}}</span>

                                    <!-- <van-icon name="arrow" size="12px" style="margin-top:6px" /> -->
                                </div>
                                <span class="checkitem-desc">{{it.description}}</span>
                                <div class="checkitem-footer">
                                    <div class="checkitem-tips-wrap">
                                        <span v-show="it.generalTips" class="checkitem-tips">{{it.generalTips}}</span>
                                        <span v-show="it.importantTips"
                                            class="checkitem-tips red">{{it.importantTips}}</span>
                                    </div>
                                    <div class="checkitem-action">
                                        <van-checkbox v-model="it.isSelected">选择</van-checkbox>
                                        <!-- <div class="checkitem-action-btn" v-if="carAddItems.indexOf(it)>=0"
                                            @click="removeCarItem(it)">
                                            <van-icon name="clear" size="14" color="#ee0a24" /> <span>移除</span>
                                        </div>
                                        <div class="checkitem-action-btn" v-else @click="addCarItem(it)">
                                            <van-icon name="add" size="14" color="#1989fa" /> <span>添加</span>
                                        </div> -->

                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- 弹出层设置 -->
        <van-popup v-model="showCar" round position="bottom">
            <div class="car-header">
                订制体检方案详情
            </div>
            <div class="car-list">
                <div class="car-item">
                    <div class="item-tag">套餐</div>
                    <div class="item-name">{{projectData.packageName}}</div>
                    <div class="item-price">￥{{packageAmount}}</div>
                    <div class="item-action"></div>
                </div>
                <div class="car-item" v-for="(combo,idx) in carAddCombos">
                    <div class="item-tag item-tag--orange">组合</div>
                    <div class="item-name">{{combo.comboName}}</div>
                    <div class="item-price">￥{{combo.price}}</div>
                    <div class="item-action"></div>
                </div>
                <div class="car-item" v-for="(carItem,idx) in carAddItems">
                    <div class="item-tag item-tag--yellow">加项</div>
                    <div class="item-name">{{carItem.name}}</div>
                    <div class="item-price">￥{{carItem.price}}</div>
                    <div class="item-action"></div>
                </div>
            </div>
        </van-popup>


        <div class="fixed-footer page-footer">
            <div class="car-wrap">
                <van-icon name="shopping-cart-o" :badge="carItemCount" size="28" color="#1989fa"
                    @click="showCar = !showCar" />
            </div>
            <div class="total-wrap">
                <div>
                    <span class="price">￥{{totalAmount}}</span>
                </div>
                <div class="price-detail">
                    <span>套餐 ￥{{packageAmount}}</span><span v-if="addItemsAmount>0">加项 ￥{{addItemsAmount}}</span>
                </div>
            </div>
            <div class="btn-wrap">
                <div class="btn" @click="order()">选好了</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {
        mapState,
        mapMutations,
        mapActions
    } from 'vuex'
    import {
        Sidebar,
        SidebarItem
    } from 'vant';
    Vue.use(Sidebar);
    Vue.use(SidebarItem);
    export default {
        name: "customizeProject",
        data() {
            return {
                projectData: {},
                showCar: false, //显示购物车明细
                packageExpand: false, //是否展开套餐详情
                addItemTabIndex: 0,
                myAdditemCateKey: 0,
            }
        },
        created() {
            this.projectData = JSON.parse(sessionStorage.getItem("customize-project"));
            this.projectData.packageItems.sort((a, b) => {
                if (a.itemType > b.itemType) {
                    return 1;
                } else if (a.itemType < b.itemType) {
                    return -1;
                } else {
                    return a.sort > b.sort ? 1 : -1;
                }
            })
        },
        mounted() {

        },

        computed: {
            ...mapState({
                activeUserProfile: state => state.user.activeUserProfile
            }),
            items0() {
                return this.projectData.packageItems.filter(it => {
                    return it.itemType == 0
                });
            },
            items1() {
                return this.projectData.packageItems.filter(it => {
                    return it.itemType == 1
                });
            },
            items2() {
                return this.projectData.packageItems.filter(it => {
                    return it.itemType == 2
                });
            },
            items3() {
                return this.projectData.packageItems.filter(it => {
                    return it.itemType == 3
                });
            },
            carAddItems() {
                return this.projectData.addItems.filter(it => {
                    return it.isSelected;
                })
            },
            carAddCombos() {
                return this.projectData.addCombos.filter(it => {
                    return it.isSelected;
                })
            },
            carItemCount() {
                return this.carAddItems.length + this.carAddCombos.length + 1;
            },
            packageAmount() {
                let amount = this.projectData.packagePrice;
                return amount;
            },
            addItemsAmount() {
                let amount = 0;
                this.projectData.addCombos.forEach(it => {
                    if (it.isSelected) {
                        amount = amount + it.price;
                    }
                });
                this.projectData.addItems.forEach(it => {
                    if (it.isSelected) {
                        amount = amount + it.price;
                    }
                });
                return amount;
            },
            totalAmount() {
                let amount = this.projectData.packagePrice;
                this.projectData.addCombos.forEach(it => {
                    if (it.isSelected) {
                        amount = amount + it.price;
                    }
                });
                this.projectData.addItems.forEach(it => {
                    if (it.isSelected) {
                        amount = amount + it.price;
                    }
                });
                return amount;
            }
        },
        methods: {
            ...mapActions(
                "user", {
                    setActiveUserProfile: "setActiveUserProfile"
                }
            ),
            ...mapActions(
                "order", {
                    setCustomizedProject: "setCustomizedProject"
                }
            ),
            ...mapActions(
                "hospital", {
                    getHospitalInfo: "getHospitalInfo"
                }
            ),
            order() {
                this.projectData.addItems = this.projectData.addItems.filter(it => {
                    return it.isSelected
                })
                this.projectData.addCombos = this.projectData.addCombos.filter(it => {
                    return it.isSelected
                })
                this.setCustomizedProject(this.projectData);
                this.$router.push({
                    path: "/submitOrder",
                    query: {
                        customized: '1'
                    }
                });
            },
        },
    }
</script>

<style lang="less" scoped>
    .page {
        padding-bottom: 100px;
    }

    .project-header {
        background-image: url("../../assets/images/bg-curve.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        min-height: 150px;
        position: relative;
        width: 100%;

        .project-title {
            font-size: 22px;
            color: #fff;
            padding: 24px 0;
            text-align: center;
        }

        .project-user {
            align-items: center;
            background: #fff;
            border-radius: 8px;
            display: flex;
            height: 110px;
            justify-content: flex-start;
            margin: 0 16px;

            .user-avatar-left {
                width: 100px;
                text-align: center;

                .user-avatar-img {
                    width: 52px;
                    height: 52px;
                }
            }

            .user-profile-right {
                .user-profile-name {
                    font-size: 18px;
                }

                .user-profile-info {
                    margin-top: 4px;
                    font-size: 14px;
                    color: #888;
                }
            }
        }
    }

    .package-wrap {
        margin: 16px;
        background: #fff;
        border-radius: 8px;

        .package-header {
            padding: 12px 16px;
            font-size: 16px;
        }

        .package-items-category {
            padding: 16px 0;
            display: flex;
            background: #fff;

            .package-items-category-box {
                flex: 1;
                text-align: center;

                .category-icon {
                    img {
                        width: 30px;
                        height: 30px;
                    }
                }

                .category-name {
                    font-size: 14px;
                }

                .category-tag {
                    background: rgba(0, 0, 0, .08);
                    border-radius: 8px;
                    font-size: 12px;
                    padding: 2px 8px;
                }
            }
        }

        .package-detail-toggle {
            padding: 12px 0;
            font-size: 12px;
            text-align: center;
        }
    }

    .additem-wrap {
        margin: 16px;
        background: #fff;
        border-radius: 8px;

        .additem-header {
            padding: 12px 16px;
            font-size: 16px;
            font-weight: 600;
            border-bottom: 1px solid #f3f3f3;

            .additem-header-subtext {
                font-size: 12px;
                color: #888;
                margin-left: 16px;
            }
        }



        .additem-main {
            display: flex;

            .additem-list {
                flex: 1;
            }
        }


    }

    .checkitem-row {
        padding: 8px;
        border-bottom: rgba(0, 0, 0, .1) solid 1px;

        .checkitem-title {
            line-height: 30px;
            font-size: 14px;
            display: flex;
            justify-content: center;
            align-content: center;
        }

        .checkitem-name {
            display: inline-block;
            flex: 1;
            font-size: 14px;
            font-weight: 600;
            line-height: 30px;
            color: #333;
        }

        .combo-pkgItem-tag {
            font-weight: 400;
            font-size: 12px;
            margin-left: 10px;
            border-radius: 3px;
            padding: 2px;
            color: #666;
            border: #666 1px solid;
        }

        .checkitem-price {
            width: 70px;
            display: block;
            font-size: 16px;
            line-height: 30px;
            color: #ff6633;
            text-align: right;
        }

        .checkitem-price:first-letter {
            font-size: 12px;
        }

        .checkitem-status {
            font-size: 13px;
            color: #ff6633;
        }

        .checkitem-desc {
            font-size: 13px;
            color: #888;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2; //（希望显示N行-webkit-line-clamp的变为N）
            -webkit-box-orient: vertical;
        }

        .checkitem-footer {
            margin-top: 8px;
            display: flex;

            .checkitem-tips-wrap {
                flex: 1;
            }

            .checkitem-action {
                .checkitem-action-btn {
                    font-size: 12px;
                    padding: 2px 4px;
                    border-radius: 8px;

                    span {
                        margin-top: 14px;
                    }
                }

                .checkitem-action-btn--add {
                    background: #1496f1;
                }

                .checkitem-action-btn--del {
                    background: #ff6633;
                }



            }
        }

        .checkitem-tips {
            color: #29a2fd;
            background: #e3f3fa;
            border-radius: 3px;
            padding: 4px 8px;
            font-size: 12px;
            margin-right: 12px;
        }

        .red {
            color: #ff6633;
            background: #faebe7;
        }

        .checkitem-button-on {
            border: #26a2ff 1px solid;
            color: #26a2ff;
            background: #fff;
            border-radius: 14px;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 90px;
            cursor: pointer;

            img {
                margin-right: 5px;
                width: 12px;
                height: 12px;
            }

            span {
                font-size: 12px;
                line-height: 16px;
            }
        }

        .checkitem-button-off {
            border: 1px solid #26a2ff;
            color: #fff;
            background: #26a2ff;
            border-radius: 14px;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 90px;
            cursor: pointer;

            img {
                margin-right: 5px;
                width: 12px;
                height: 12px;
            }

            span {
                font-size: 12px;
                line-height: 16px;
            }
        }

        .item-tag {
            font-size: 10px;
            color: #333;
            padding: 2px 4px;
            border-radius: 4px;
            margin-right: 8px;
        }

        .item-tag--orange {
            color: #fc5531;
            border: 1px solid #fc5531;
        }

        .item-tag--yellow {
            color: #f0a210;
            border: 1px solid #f0a210;
        }
    }


    .page-footer {
        display: flex;
        justify-content: center;
        align-items: center;

        .car-wrap {
            margin-left: 16px;
        }

        .total-wrap {
            flex: 1;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.7);
            // font-weight: 300;
            padding: 6px 12px;

            .price {
                font-size: 18px;
                font-weight: 600;
                color: #ff6633;
            }

            .price-detail {
                font-size: 12px;

                span {
                    margin-right: 16px;
                }
            }
        }

        .btn-wrap {
            .btn {
                width: 90px;
                height: 32px;
                border-radius: 16px;
                text-align: center;
                line-height: 32px;
                font-size: 14px;
                font-weight: 600;
                background: #1496f1;
                color: #fff;
                // border: 1px solid var(--color-main);
                margin-right: 8px;
            }
        }
    }

    .car-header {
        padding: 12px 16px 4px 16px;
    }

    .car-list {
        min-height: 200px;
        max-height: 70%;
        overflow-y: auto;
        padding: 16px;
        padding-bottom: 60px;

        .car-title {
            font-size: 16px;
            font-weight: 600;
        }

        .car-item {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            margin-bottom: 16px;

            .item-tag {
                font-size: 10px;
                color: #fff;
                background: #1496f1;
                padding: 2px 4px;
                border-radius: 4px;
                margin-right: 8px;
            }

            .item-tag--orange {
                background: #fc5531;
            }

            .item-tag--yellow {
                background: #f0a210;
            }

            .item-name {
                flex: 1;
            }
        }
    }

    /deep/ .fixed-footer {
        z-index: 9999;
    }
</style>